var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForwardChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5_58",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5_58)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3438 7.62488L14.0937 11.3748L10.3438 15.125",
    stroke: "#1564E8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5312 11.3751H0.624939",
    stroke: "#1564E8",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.68773 0.875L1.93756 4.62494L5.68751 8.37489",
    stroke: "#1564E8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.50012 4.62488H15.3751",
    stroke: "#1564E8",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardChat);
export default __webpack_public_path__ + "static/media/forward-chat.a918f3475be480480d290fff20859b3a.svg";
export { ForwardRef as ReactComponent };